import { TableCell as MuiTableCell, tableCellClasses } from '@mui/material';
import { styled } from '@mui/material/styles';

const TableCell = styled(MuiTableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: theme.palette.mode === 'dark' ? '#2A2A2A' : '#F5F5F5',
    color: theme.palette.mode === 'dark' ? '#FFFFFF' : '#424242',
    fontWeight: 600,
    borderBottom: theme.palette.mode === 'light' ? '1px solid #E0E0E0' : '1px solid #424242'
  }
}));

export default TableCell;
